import { render, staticRenderFns } from "./SMANgbTeamMembersModify.vue?vue&type=template&id=21cb08c0"
import script from "./SMANgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./SMANgbTeamMembersModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports